import type { ReactElement } from 'react';
import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

import { AppliedInvoiceBody } from './applied-invoice-body.component';
import { AppliedInvoiceFooter } from './applied-invoice-footer.component';
import { AppliedInvoiceHeader } from './applied-invoice-header.component';

const initialAnimationState = { height: 0 };
const finalAnimationState = { height: 'auto' };

export const AppliedInvoice = ({
  border
}: Record<string, boolean>): ReactElement => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleCollapse = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div
      className={`co-w-full co-flex co-rounded-8px co-flex-wrap co-h-auto co-px-4 co-py-3 co-bg-pds-primary-100 ${border && 'co-border'} ${isOpen ? 'co-border-primary-500' : 'co-border-gray-xxxlight'}`}
    >
      <div
        className="co-flex co-flex-col co-w-full co-gap-2 co-cursor-pointer"
        onClick={toggleCollapse}
      >
        <AppliedInvoiceHeader isOpen={isOpen} />
      </div>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="co-w-full co-h-auto co-overflow-hidden"
            initial={initialAnimationState}
            animate={finalAnimationState}
            exit={initialAnimationState}
            transition={{ duration: 0.3 }}
          >
            <AppliedInvoiceBody />
          </motion.div>
        )}
      </AnimatePresence>
      <AppliedInvoiceFooter />
    </div>
  );
};
